import * as glslify from 'glslify';
import * as THREE from 'three'
import Context from "../../Context";

class fboHelper {


    constructor() {

        this.isInit = false;
        this.renderer = null;
        this.quadGeom = null
        this.triGeom = null
        this.geometry = null;
        this.clearMaterial = null;
        this.floatType = null;
        this.precisionPrefix = "";
        this.precisionPrefix2 = "";
        this.vertexShader = "";
        this.obj = void 0;
        this.el = void 0;
        this.value = void 0;
        this.t = void 0;
        this.batch = void 0;
        this.shader = void 0;

    }


    /**
     * @param {!Object} key
     * @param {string} input
     * @return {undefined}
     */
    render(key, input) {

        if (!this.isInit) {
            this.init(Context.renderer);
        }

        // if (key) {
        this.value.material = key;
        if (input) {
            this.renderer.setRenderTarget(input);
        }
        this.renderer.render(this.obj, this.el);
        if (input) {
            this.renderer.setRenderTarget(null);
        }
        // }

    }

    /**
     * @return {?}
     */
    update() {
        if (!this.isInit) {
            this.init(Context.renderer);
        }

        return {
            autoClear: this.renderer.autoClear,
            autoClearColor: this.renderer.autoClearColor,
            autoClearStencil: this.renderer.autoClearStencil,
            autoClearDepth: this.renderer.autoClearDepth,
            clearColor: this.renderer.getClearColor().getHex(),
            clearAlpha: this.renderer.getClearAlpha()
        };
    }


    /**
     * @param {!Object} renderer
     * @param {number} coptions
     * @return {undefined}
     */
    init(renderer/*, coptions*/) {

        this.isInit = true;

        /* context.RENDER_TARGET_FLOAT_TYPE */
        var coptions = 1015;

        /** @type {!Object} */
        this.renderer = renderer;
        /** @type {number} */
        this.floatType = coptions;
        this.obj = new THREE.Scene;
        /** @type {number} */
        (this.el = new THREE.Camera).position.z = 1;
        (this.geometry = this.triGeom = new THREE.BufferGeometry).setAttribute("position", new THREE.BufferAttribute(new Float32Array([-1, -1, 0, 4, -1, 0, -1, 4, 0]), 3));
        this.quadGeom = new THREE.PlaneBufferGeometry(2, 2);
        /** @type {boolean} */
        (this.value = new THREE.Mesh(this.geometry)).frustumCulled = false;
        this.obj.add(this.value);
        /** @type {string} */
        var v = this.precisionPrefix = "precision " + this.renderer.capabilities.precision + " float;\n";
        /** @type {string} */
        this.precisionPrefix2 = "#version 300 es\nprecision " + this.renderer.capabilities.precision + " float;\nprecision " + this.renderer.capabilities.precision + " int;\n#define IS_WEBGL2 true\n";
        this.vertexShader = v + glslify(["#define GLSLIFY 1\nattribute vec3 position;\nvarying vec2 v_uv;\n\nvoid main() {\n    v_uv = position.xy * 0.5 + 0.5;\n    gl_Position = vec4(position, 1.0 );\n}\n"]);
        this.copyMaterial = new THREE.RawShaderMaterial({
            uniforms: {
                u_texture: {
                    value: null
                }
            },
            vertexShader: this.vertexShader,
            fragmentShader: v + glslify(["#define GLSLIFY 1\nuniform sampler2D u_texture;\n\nvarying vec2 v_uv;\n\nvoid main () {\n    gl_FragColor = texture2D(u_texture, v_uv);\n}\n"]),
            depthTest: false,
            depthWrite: false,
            blending: THREE.NoBlending
        });
        this.uvCopyMaterial = new THREE.RawShaderMaterial({
            uniforms: {
                u_texture: {
                    value: null
                }
            },
            vertexShader: v + glslify(["#define GLSLIFY 1\nattribute vec3 position;\nattribute vec2 uv;\nvarying vec2 v_uv;\n\nvoid main() {\n    v_uv = uv;\n    gl_Position = vec4(position, 1.0 );\n}\n"]),
            fragmentShader: v + glslify(["#define GLSLIFY 1\nuniform sampler2D u_texture;\n\nvarying vec2 v_uv;\n\nvoid main () {\n    gl_FragColor = texture2D(u_texture, v_uv);\n}\n"]),
            depthTest: false,
            depthWrite: false,
            blending: THREE.NoBlending
        });
        this.clearMaterial = new THREE.RawShaderMaterial({
            uniforms: {
                u_color: {
                    value: new THREE.Vector4(1, 1, 1, 1)
                }
            },
            vertexShader: v + glslify(["#define GLSLIFY 1\nattribute vec3 position;\n\nvoid main() {\n    gl_Position = vec4(position, 1.0 );\n}\n"]),
            fragmentShader: v + glslify(["#define GLSLIFY 1\nuniform vec4 u_color;\n\nvoid main () {\n    gl_FragColor = u_color;\n}\n"]),
            depthTest: false,
            depthWrite: false,
            transparent: true,
            blending: THREE.NoBlending
        });
        this.t = new THREE.Scene;
        var mesh = new THREE.PlaneBufferGeometry(1, 1);
        mesh.translate(.5, -.5, 0);
        this.shader = new THREE.RawShaderMaterial({
            uniforms: {
                u_texture: {
                    value: null
                },
                u_transform: {
                    value: new THREE.Vector4(0, 0, 1, 1)
                }
            },
            vertexShader: v + glslify(["#define GLSLIFY 1\nattribute vec3 position;\nattribute vec2 uv;\n\nuniform vec4 u_transform;\n\nvarying vec2 v_uv;\n\nvoid main() {\n    v_uv = uv;\n    gl_Position = vec4( position.xy * u_transform.zw + u_transform.xy, 0.0, 1.0 );\n}\n"]),
            fragmentShader: v + glslify(["#define GLSLIFY 1\nuniform sampler2D u_texture;\n\nvarying vec2 v_uv;\n\nvoid main () {\n    gl_FragColor = texture2D(u_texture, v_uv);\n}\n"]),
            depthTest: false,
            depthWrite: false,
            blending: THREE.NoBlending
        });
        this.batch = new THREE.Mesh(mesh, this.shader);
        /** @type {boolean} */
        this.t.frustumCulled = false;
        this.t.add(this.batch);
    };
    /**
     * @param {!Object} name
     * @param {string} container
     * @return {undefined}
     */
    copy(name, container) {
        var me = this.copyMaterial;
        /** @type {!Object} */
        me.uniforms.u_texture.value = name;
        render(me, container);
    };
    /**
     * @param {!Object} htmlString
     * @param {undefined} params
     * @return {undefined}
     */
    uvCopy(htmlString, params) {
        var me = this.uvCopyMaterial;
        /** @type {!Object} */
        me.uniforms.u_texture.value = htmlString;
        render(me, params);
    };
    /**
     * @param {!Object} promise
     * @param {undefined} index
     * @param {string} view
     * @return {undefined}
     */
    renderGeometry(promise, index, view) {
        /** @type {!Object} */
        this.value.geometry = promise;
        this.render(index, view);
        /** @type {null} */
        this.value.geometry = this.geometry;
    };
    /**
     * @param {undefined} mesh
     * @param {string} material
     * @return {undefined}
     */
    renderMesh(mesh, material) {
        /** @type {boolean} */
        this.value.visible = false;
        this.obj.add(mesh);
        if (material) {
            renderer.setRenderTarget(material || null);
        }
        renderer.render(obj, el);
        if (material) {
            renderer.setRenderTarget(null);
        }
        this.obj.remove(mesh);
        /** @type {boolean} */
        this.value.visible = true;
    };
    /**
     * @param {!Object} dt
     * @param {number} count
     * @param {number} value
     * @param {number} result
     * @param {number} diff
     * @return {undefined}
     */
    debugTo(dt, count, value, result, diff) {
        /** @type {number} */
        count = count || 200;
        /** @type {number} */
        value = value || 200;
        /** @type {number} */
        result = result || 0;
        /** @type {number} */
        diff = diff || 0;
        var options = renderer.getSize(new THREE.Vector2);
        /** @type {number} */
        result = result / this.width * 2 - 1;
        /** @type {number} */
        diff = 1 - diff / this.height * 2;
        /** @type {number} */
        count = count / this.width * 2;
        /** @type {number} */
        value = value / this.height * 2;
        /** @type {!Object} */
        shader.uniforms.u_texture.value = dt;
        shader.uniforms.u_transform.value.set(result, diff, count, value);
        update();
        /** @type {boolean} */
        renderer.autoClearColor = false;
        renderer.setRenderTarget(null);
        renderer.render(t, el);
        update();
    };

    /**
     * @param {number} r
     * @param {number} g
     * @param {number} b
     * @param {number} c
     * @param {undefined} name
     * @return {undefined}
     */
    clearColor(r, g, b, c, name) {
        /** @type {null} */
        var material = this.clearMaterial;
        material.uniforms.u_color.value.set(r, g, b, c);
        /** @type {boolean} */
        material.transparent = c < 1;
        material.blending = c < 1 ? THREE.NormalBlending : THREE.NoBlending;
        render(this.clearMaterial, name);
        /** @type {boolean} */
        material.transparent = false;
        material.blending = THREE.NoBlending;
    };

    /** @type {function(): ?} */
    getColorState() {
        return this.update();
    }

    /**
     * @param {!Object} options
     * @return {undefined}
     */
    setColorState(options) {
        this.renderer.setClearColor(this.clearColor, options.clearAlpha);
        this.renderer.autoClear = options.autoClear;
        this.renderer.autoClearColor = options.autoClearColor;
        this.renderer.autoClearStencil = options.autoClearStencil;
        this.renderer.autoClearDepth = options.autoClearDepth;
    };

    /**
     * @param {number} w
     * @param {number} h
     * @param {boolean} useRGBA
     * @param {boolean} flat
     * @param {boolean} type
     * @return {?}
     */
    createRenderTarget(w, h, useRGBA, flat, type)  {
        return new THREE.WebGLRenderTarget(w, h, {
            wrapS: THREE.ClampToEdgeWrapping,
            wrapT: THREE.ClampToEdgeWrapping,
            magFilter: flat ? THREE.NearestFilter : THREE.LinearFilter,
            minFilter: flat ? THREE.NearestFilter : THREE.LinearFilter,
            format: useRGBA ? THREE.RGBAFormat : THREE.RGBFormat,
            type: type ? this.floatType : THREE.UnsignedByteType,
            anisotropy: 0,
            encoding: THREE.LinearEncoding,
            depthBuffer: false,
            stencilBuffer: false
        });
    };

    /**
     * @param {number} l
     * @param {number} h
     * @param {number} useRGBA
     * @param {number} flat
     * @param {number} type
     * @return {?}
     */
    createMultisampleRenderTarget(l, h, useRGBA, flat, type) {
        return new THREE.WebGLMultisampleRenderTarget(l, h, {
            wrapS: THREE.ClampToEdgeWrapping,
            wrapT: THREE.ClampToEdgeWrapping,
            magFilter: flat ? THREE.NearestFilter : THREE.LinearFilter,
            minFilter: flat ? THREE.NearestFilter : THREE.LinearFilter,
            format: useRGBA ? THREE.RGBAFormat : THREE.RGBFormat,
            type: type ? this.floatType : THREE.UnsignedByteType,
            anisotropy: 0,
            encoding: THREE.LinearEncoding,
            depthBuffer: false,
            stencilBuffer: false
        });
    };

}

const fpoHelperInstance = new fboHelper();

export default fpoHelperInstance;
